import { TableNames } from '../../../customEnums/TableNames';
import { urls } from "../../../urls";

const url = urls.BATCHPRINT;

export const handleRequestSort = (
    event: any, 
    property: any, 
    setPagination: Function, 
    pagination: any,
    orderBy: any,
    order: any
) => {

    let currentProperty = property != "fullName" ? property : "firstName"
    const isAsc = orderBy === currentProperty && order === 'asc';

    setPagination({
        ...pagination,
        [TableNames.BATCH_PRINTING]: {
            ...pagination[TableNames.BATCH_PRINTING],
            order: isAsc ? 'desc' : 'asc',
            orderBy: currentProperty
        }
    })
};

export const handleSubmitTcns = async (setBatchPrintSteps: Function, tcns: any, setResp: Function) => {
    setBatchPrintSteps((prevSteps: any) => { return { ...prevSteps, stepA_Confirm: false, stepB_PreparePdf: true } })
    const body = {
        inputTcns: tcns.map((row: any) => row.transactionNumber)
    }

    try {
        let { message, batchPrintJob } = await (await (fetch(`${process.env.NODE_ENV === "production" ? url : ""
            }/batchprint/tcns-submission`, {
            method: 'POST',
            body: JSON.stringify(body),
            credentials: 'include'
        }))).json()

        setResp({ message, batchPrintJob })
    } catch (e: any) {
        console.error('Error submmitinc tcns: ', e)
    }
}

export const getPdfUrl = async (tcnResp: any, checkUrl: any ) => {
    console.log('batch print flow getPdfUrl running')
    const bodyObj = {
        batchPrintJob: tcnResp.batchPrintJob
    }
    let body = JSON.stringify(bodyObj)
    try {
        let resp = await (await (fetch(`${process.env.NODE_ENV === "production" ? url : ""
            }/batchprint/presigned-url`, {
            method: 'POST',
            body,
            credentials: 'include'
        }))).json()

        console.log('batch print flow getPdfUrl resp: ', resp)
        const { status } = resp
        if (status === "Processing") {
            setTimeout(() => {
                getPdfUrl(tcnResp, checkUrl);
            }, 2000)
        } else {
            //Check for 200 resp from preSignedUrl
            const { message, presignedS3Url } = resp
            try {
                checkUrl(presignedS3Url)
                console.log('batch print flow getPdfUrl check for 200 on presignedUrl: ', resp)

            } catch (e: any) {
                console.error('batch print flow getting presigned url response: ', e)
            }

            if (message && presignedS3Url) {
                return { status, message, presignedS3Url }
            }
        }
    } catch (e: any) {
        console.error('Error getting pdf url ', e)
    }
}

export const batchPrintStepsObject = {
    stepA_Confirm: true,
    stepB_PreparePdf: false,
    stepC_DocumentReady: false,
    stepD_Confirm: false,
    cancelConfirmPrint: false,
    cancelConfirmError: false,
    docExpired: false,
    pdfGenError: false,
    confirmingPrintJobs: false,
}